import { z } from "zod";

export const ProcedureCheckSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  agent: z.string(),
  instructions: z.string(),
  createdAt: z.string().or(z.date()),
  updatedAt: z.string().or(z.date()),
});

export type ProcedureCheck = z.infer<typeof ProcedureCheckSchema>;
